export default __webpack_public_path__ + "static/media/game_insects.98d17857.png";